import { useReportData } from '../../../hooks/data/useReportData';
import SearchBarV2 from '../../../components/common/SearchBarV2';
import SelectBoxV2 from '../../../components/common/SelectBoxV2';
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from '../../../components/sidebar/Sidebar';
import { searchReport } from '../../../utils/api/search';
import NavBar from '../../../components/navbar/NavBar';
import verifyToken from '../../../utils/tokenUtils';
import { useNavigate } from 'react-router-dom';
import  { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Cookies from 'js-cookie';
import './poStatusReport.css';

const STATUS_COLORS = {
  "Br Received":"#6c757d",
  "In Transit": "#1976d2",
  "Delivered":"#1b5e20",
  "Hot Shipment": "#d32f2f",
  "Delivery Appt Confirmed": "#2e7d32",
  "Unknown": "#757575"
};

const selectConfig = {
  label: 'Search By', smallSize: true,
   menuItems: [ 
    { label: "PO Number", value: "po_number" },
    { label: "Supplier Name", value: "supplier_name" },
    { label: "Carrier Name", value: "carrier_name" },
    { label: "Shipment Total Cost", value: "shipment_total_cost" },
  ],
};

const getStatusColor = (status) =>
  STATUS_COLORS[status] || "#9e9e9e";

const BiovPoStatusReport = () => {
  const navigate = useNavigate();
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); };

  const [selectedField, setSelectedField] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchRows, setSearchRows] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [expandedStatuses, setExpandedStatuses] = useState([]);

  const response = useReportData('biov po management header', 800);
  const baseData = response?.data?.data ?? [];
  const dataToRender = searchRows.length > 0 ? searchRows : baseData;

  useEffect(() => { 
    const token = getAuthToken();
    token ? verifyToken(token) : navigate('/');
  }, []);

  const handleSeeMoreClick = (status) => {
    setExpandedStatuses((prevState) => ({
      ...prevState,
      [status]: !prevState[status],
    }));
  };

  const handleTaskClick = (taskname, taskID) => {
    navigate(`/poStatusReport/task/${taskname}`, {state: { taskID }});
  };

  const handleSubmit = async () => {
    setLoading(true);
    const res = await searchReport({
      reportId: 14, searchKey: selectedField, searchValue: searchValue,
    });
    setSearchRows(res.dataResults)
    setLoading(false);
  };
  
  return (
    <div className='clickupConnectPage'> 
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
         <div className="clickupConnectPageContent">
          <div className="clickupConnectTop">
            <div className="clickupConnectTitle">
              <h1>PO Status Report</h1>
            </div>
          </div>
          <div className="clickupConnectMid">
            <div className="poStatusReportSearch">
              <SelectBoxV2
                value={selectedField}
                onChange={setSelectedField}
                selectObject={selectConfig}
              />
              <div style={{ flex: '0 0 40%' }}>
                <SearchBarV2
                  value={searchValue}
                  onChange={setSearchValue}
                  onSearch={handleSubmit}
                  config={{ label: "Search", size: "small", keyPress: true }}
                />
              </div>
              <Button 
                variant='contained' 
                sx={{ height: 40, px: 3 }}
                onClick={handleSubmit}>
                  Search
              </Button>
            </div>
              {<div className="reportSpaced">
                <ul className='bodyClass'>
                  {loading ? (
                    <div><p>Loading PO tasks...</p>
                      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                      </Box>
                  </div>
                  ) : dataToRender.length === 0 ? (
                    <p>Loading Tasks...</p>
                  ) : (
                    Object.entries(
                      dataToRender.reduce((acc, task) => {
                        const statusName = task.STATUS
                          ? task.STATUS
                              .split(' ')
                              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')
                          : 'Unknown';
                    
                        if (!acc[statusName]) acc[statusName] = [];
                        acc[statusName].push(task);
                        return acc;
                      }, {})
                    ).map(([status, tasks]) => {
                      const tasksToShow = expandedStatuses[status] ? tasks : tasks.slice(0, 5);

                      return (
                        <div key={status}>
                          <h2>{status}</h2>
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr>
                                <th className='tdStyle' style={{width: '5%'}}>PO Number</th>
                                <th className='tdStyle' style={{width: '5%'}}>BOL#</th>
                                <th className='tdStyle' style={{width: '5%'}}>Carrier</th>
                                <th className='tdStyle' style={{width: '5%'}}>Pro Number</th>
                              </tr>
                            </thead> 
                             <tbody className='boxShadow'>
                              {tasksToShow.map(task => (
                                <tr
                                  key={task.ID}
                                  onClick={() => handleTaskClick(task.NAME, task.ID)}
                                  className='handleHover'
                                >
                                  <td className='tdStyle2'>
                                    <div
                                      style={{
                                        width: '20px',
                                        height: '20px',
                                        borderRadius: '50%',
                                        backgroundColor: getStatusColor(status)
                                      }}
                                    />
                                    {task.PURCHASE_ORDER}
                                  </td>
                                  <td className='tdStyle'>{task.BOL_NUMBER}</td>
                                  <td className='tdStyle'>{task.CARRIER}</td>
                                  <td className='tdStyle'>{task.PRO_NUMBER}</td>
                                </tr>
                              ))}
                            </tbody> 
                           </table>
                          <p onClick={() => handleSeeMoreClick(status)} className="seeMore" style={{ cursor: 'pointer', color: 'blue' }}>
                            {expandedStatuses[status] ? 'See Less' : 'See More'}
                          </p>
                          <hr style={{ color: 'black', height: '1px', backgroundColor: 'black'}} />
                        </div>
                      );
                    })
                  )}
                </ul>
            </div>
            }
          </div>
        </div>
      </div> 
    </div>
  );
};

export default BiovPoStatusReport